export default "__VITE_ASSET__BVdCaxOU__"